import {createAction, createReducer} from 'redux-act';
import {fetchQuoteItemV2} from 'actions/cart/cart';
import {selectPrescription} from 'features/wizardMs/reducers/prescription/prescription/prescription';

export const initialState = false;

export const setShouldUpdatePrescription = createAction(
    'SET_SHOULD_UPDATE_PRESCRIPTION',
    payload => payload,
);

export const shouldUpdate = createReducer<boolean>(
    {
        [`${setShouldUpdatePrescription}`]: (state: boolean, payload: boolean) => payload,
        [`${fetchQuoteItemV2}_FULFILLED`]: () => false,
        [`${selectPrescription}`]: () => false,
    },
    initialState,
);
